import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import * as yup from 'yup';

import { addImplementator } from 'actions/adminTool';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useToast from 'hooks/useToast';

import { Container, Wrapper, FormContainer, Field } from './styles';
import useStoreTranslation from 'hooks/useStoreTranslation';

const AdminToolAddImplementator = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [userPassword, setUserPassword] = useState('');
  const [username, setUsername] = useState('');

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      
      const userAdded = await addImplementator(
        values.companyDocumentNumber,
        values.name,
        values.lastName,
        values.email,
        values.username,
      );
      
      toast.add({ type: 'success', message: t('adminTool.addImplementatorForm.toastSuccess') });
      setUserPassword(userAdded?.data?.data?.password);
      setUsername(values.username);

    } catch (error: any) {
            
        let errorMessage = 'An unexpected error occurred.';
    
        // Verifica se o erro é uma instância de Error
        if (error instanceof Error) {
          errorMessage = error.message;
        }
    
        // Verifica se há uma resposta de erro da API
        if (error?.response?.data?.error) {
          errorMessage += ` - ${error.response.data.error}`;
        }
    
        toast.add({ type: 'danger', message: errorMessage });
      }

    setIsLoading(false);
  };

  const validationSchema = yup.object().shape({
    companyDocumentNumber: yup.string().required(),
    name: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    username: yup.string().required(),
  });

  const initValues = {
    companyDocumentNumber: '',
    name: '',
    lastName: '',
    email: '',
    username: '',
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/admintool')}>{t('adminTool.addImplementatorForm.title')}</Header>
        </Mobile>

        <Desktop>      
          <ScreenHeader title={t('adminTool.addImplementatorForm.title')} subtitle={t('adminTool.addImplementatorForm.subtitle')} />
        </Desktop>

        <Container>
            <Section hide={!userPassword} joinContent={true}>
                <Container><h3>{t('adminTool.addImplementatorForm.successMessage')}</h3> <br></br> 
                    <h4><b>Username:</b> {username}<br />
                    <b>Password:</b> {userPassword}</h4>
                </Container>
            </Section>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values, setFieldValue }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer marginBottom={dirty}>
                  <Section title={t('adminTool.addImplementatorForm.parameters')} joinContent={true}>
                    <Field name="companyDocumentNumber" label={t('adminTool.addImplementatorForm.documentReseller')}>
                      <Input placeholder="" />
                    </Field>
                    <Field name="name" label={t('adminTool.addImplementatorForm.firstName')}>
                      <Input placeholder="" />
                    </Field>
                    <Field name="lastName" label={t('adminTool.addImplementatorForm.lastName')}>
                      <Input placeholder=""  />
                    </Field>
                    <Field name="email" label={t('adminTool.addImplementatorForm.email')}>
                      <Input placeholder="email@email.com" />
                    </Field>
                    <Field name="username" label={t('adminTool.addImplementatorForm.username')}>
                      <Input placeholder="" />
                    </Field>
                    <br />
                    <br />
                  </Section>
                  <SubmitButton dirty={true} isEdit loading={isLoading}>
                    {t('adminTool.addImplementatorForm.button')}
                  </SubmitButton>

                  <Section hide={!userPassword} joinContent={true}>
                    <Container><h3>{t('adminTool.addImplementatorForm.successMessage')}</h3> <br></br> 
                      <h4><b>Username:</b> {username}<br />
                      <b>Password:</b> {userPassword}</h4>
                    </Container>
                  </Section>
                
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default AdminToolAddImplementator;
